<template>
	<div class="ui card layout-card">
		<div class="image"></div>
		<div class="content">
			<div class="header">{{ layout.layoutName }}</div>
			<div class="meta">{{ layout.subType }}</div>
			<div class="description" v-if="layout.specialId" style="font-style: italic">Default for new {{ layout.subType }} ads</div>
		</div>
		<div class="extra content ui buttons">
			<a class="ui positive icon button" :href="composerLink"><i class="right chevron icon"></i> Edit</a>

			<div class="ui floating dropdown icon button action-dropdown" ref="dropdown"><i class="dropdown icon"></i>
				<div class="menu">
					<div class="item" @click="markDefault" v-if="!global"><i class="linkify icon"></i>Set as default</div>
					<div class="item" @click="editName"><i class="edit icon"></i>Edit Name</div>
					<div class="item" @click="duplicateLayout"><i class="cut icon"></i>Duplicate Template</div>
					<div class="item" @click="deleteLayout"><i class="trash icon"></i>Delete Template</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['layout', 'defaultBookFormat', 'global', 'isStudio'],
	data() {
		return {
			previewBox: null
		};
	},
	computed: {
		composerLink() {
			if(this.defaultBookFormat && this.defaultBookFormat.formatId) {
				return '/Composer.php?layoutId=' + this.layout.layoutId + '&formatId=' + this.defaultBookFormat.formatId;
			} else {
				return '/Composer.php?layoutId=' + this.layout.layoutId;
			}
		}
	},
	watch: {
		layout: function() {
			this.previewBox.setLayout(this.layout);
			$(this.$refs.dropdown).find('.layout-actions-dropdown').removeClass('loading');
		}
	},
	methods: {
		handleWindowResize() {
			$.setSingleTimeout.call(this, 'delayedLayoutPreviewResize', function() {
				let cardWidth = $(this.$el).width() - 2;
				this.previewBox.setPreviewWidth(cardWidth);
			}, 50);
		},

		markDefault() {
			let button = $(this.$refs.dropdown);
			$.Confirm('Set as the default ad template', 'All new ads created with this size will automatically start with this template', () => {
				button.addClass('loading');
				var specialId = 'Default ' + this.layout.subType;
				$.ajax({
					url: 'ajax/saveLayout.php',
					data: {
						layoutId: this.layout.layoutId,
						specialId,
						composer: true
					},
					dataType: 'json',
					type: 'POST',
					success: () => {
						button.removeClass('loading');
						this.$emit('updateSpecialId', this.layout, specialId);
					},
					error: () => {
						button.removeClass('loading');
						$.Alert('Error', 'Failed to set as default');
					}
				});
			});
		},
		editName() {
			let button = $(this.$refs.dropdown);
			$.EditNameModal('Edit Name', 'Template Name', this.layout.layoutName, (newName) => {
				button.addClass('loading');

				$.ajax({
					url: 'ajax/saveLayout.php',
					data: {
						layoutId: this.layout.layoutId,
						layoutName: newName,
						studioLayouts: this.isStudio,
						customerLayout: !this.isStudio
					},
					dataType: 'json',
					type: 'POST',
					success: () => {
						this.layout.layoutName = newName;
						button.removeClass('loading');
					},
					error: () => {
						button.removeClass('loading');
						$.Alert('Error', 'Failed to edit template name');
					}
				});
			});
		},
		duplicateLayout() {
			$.SettingsBuilderDialog([
				{
					id: 'name',
					type: 'text',
					defaultValue: this.layout.layoutName + ' (Copy)'
				}
			], {
				title: 'Duplicate ' + this.layout.layoutName,
				onSettingsApplied: (settings) => {
					this.$emit('insertLayout', {
						...settings,
						adSize: this.layout.subType,
						definition: JSON.stringify(this.layout.definition)
					});
				}
			});
		},
		deleteLayout() {
			let button = $(this.$refs.dropdown);

			$.ConfirmDelete('Delete ' + this.layout.layoutName, 'Are you absolutely sure you want to permanently delete this template?', () => {
				button.addClass('loading');
				$.ajax({
					url: 'ajax/deleteLayout.php',
					data: {
						id: this.layout.layoutId,
						studioLayouts: this.isStudio,
						customerLayout: !this.isStudio
					},
					dataType: 'json',
					type: 'POST',
					success: () => {
						this.$emit('deleteLayout', this.layout);
						button.removeClass('loading');
					},
					error: () => {
						button.removeClass('loading');
						$.Alert('Error', 'Failed to delete template');
					}
				});
			});
		}
	},
	mounted() {
		let layoutDiv = $(this.$el).children('.image');
		let cardWidth = $(this.$el).width() - 2;

		$.AdDB = function() {};
		let adPageSet = new $.AdPageSet();
		adPageSet.layoutDimensions = this.defaultBookFormat.definition;
		adPageSet.size = this.layout.subType || this.layout.layoutName.replace(' Template', '');
		let adPage = new $.AdPage();
		adPage.loadFromLayout(this.layout);
		adPageSet.addPage(adPage, null, false);
		let gridLayout = adPage.getLayout();
		this.layout.definition.grid = gridLayout.grid;
		if(this.layout.definition?.theme) {
			if(!this.layout.definition.images) {
				this.layout.definition.images = {};
			}
			let grid = this.layout.definition.grid;
			let backgroundWidth = grid.width - grid.bleed.left - grid.bleed.right;
			let backgroundHeight = grid.height - grid.bleed.top - grid.bleed.bottom;
			let backgroundCrop = null;
			if(this.layout.definition.extras && this.layout.definition.extras.backgroundSettings && this.layout.definition.extras.backgroundSettings.crop) {
				backgroundCrop = $.extend(true, {}, this.layout.definition.extras.backgroundSettings.crop, {
					percentage: true
				});
			}

			let theme = this.layout.definition.theme;
			this.layout.definition.images[theme.Background.id] = {
				id: theme.Background.id,
				x: 0,
				y: 0,
				width: backgroundWidth,
				height: backgroundHeight,
				photo: theme.Background.id,
				cdnUrl: theme.Background.cdnUrl,
				photoWidth: theme.Background.photoWidth,
				photoHeight: theme.Background.photoHeight,
				photo_name: theme.Background.photo_name,
				zIndex: Object.values(this.layout.definition.images).reduce((minZ, image) => Math.min(minZ, image.zIndex || 0), 0) - 1,
				crop: backgroundCrop
			}
			delete this.layout.definition.theme;
		}

		this.previewBox = new $.LayoutPreview({
			previewBox: layoutDiv,
			previewWidth: cardWidth,
			maxHeight: 300,
			displayGrid: true
		});
		this.previewBox.setLayout(this.layout);

		$(this.$refs.dropdown).dropdown({
			action: 'hide'
		});

		window.addEventListener('resize', this.handleWindowResize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleWindowResize);
	}
};
</script>

<style scoped>
.ui.buttons .action-dropdown {
	flex-grow: 0;
}
</style>